import { MessageCircle } from 'lucide-react';
import { Commentable } from '@/shared/comments/Commentable';
import { useChat } from '@/versions/v1/shared/ChatContext';
import { ASSISTANT_MODE_LABEL } from '@/versions/v1/shared/assistant/rules'; // fork(oem)
import { ChatShell } from './chat/ChatShell';

/**
 * Docked AI rail for non-chat-first routes (settings, admin, project modules).
 *
 * fork(oem): labelled "AI · Service assist" — the rail is the OEM+ service
 * assistant on every route, not a generic chat panel. The header's scope slot
 * carries the demo's `#ai-mode` badge (demo line 1458): which engine answers.
 */
export function AIRail() {
  const { railOpen, openRail, closeRail } = useChat();

  if (!railOpen) {
    return (
      <Commentable name="AIRail">
        <button
          type="button"
          className="ai-fab"
          onClick={() => openRail()}
          title="Open the service assistant"
          aria-label="Open the service assistant"
        >
          <MessageCircle size={20} aria-hidden="true" />
        </button>
      </Commentable>
    );
  }

  return (
    <Commentable name="AIRail">
      <aside
        className="relative flex h-full w-full flex-col bg-[var(--background)]"
        aria-label="AI · Service assist"
        style={{ ['--thread-max-width' as string]: '44rem' }}
      >
        <ChatShell
          helpDoc="workspace/chat-rail"
          helpLabel="AI · Service assist"
          scopeLabel={ASSISTANT_MODE_LABEL} // fork(oem): assistant mode badge
          showMinimize
          onMinimize={() => closeRail()}
          storageKey="mock-ui:docked-rail-chat-files"
        />
      </aside>
    </Commentable>
  );
}
